import React, { useEffect, useState } from "react";
import { Row, Col, ListGroup, Card, Form, Modal } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import Title from '../../../pageTitle/default.js';
import { useForm } from "react-hook-form";
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../../../common/storeContext';
import { useMiddletier } from "../../../../common/middletier";
import Loading from '../../../../components/Loading';
import DatePicker from 'react-datepicker';
import AddressDialog from "../../../../components/AddressDialog"
import '../../../../../node_modules/react-datepicker/dist/react-datepicker.css';

import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';

const UserInfo = () => {
    const appState = useStoreState()
    const { queries, mutation } = useMiddletier()
    const [userInfo, setUserInfo] = useState([]);
    const [address, setAddress] = useState([]);
    const [addressDialogShow, setAddressDialogShow] = useState({ open: false, defaultContent: '', currentItem: {} });
    const [dobEdit, setDobEdit] = useState(false);
    const [refreshBrithday, setRefreshBrithday] = useState(false);
    const [refreshAddress, setRefreshAddress] = useState(false);
    // const [currentItem, setCurrentItem] = useState({});
    const [isLoading, setLoading] = useState(false);
    const appDispatch = useStoreDispatch()
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectedDob, setSelectedDob] = useState('');
    const [disabledSubmit, setDisabledSubmit] = useState(true);


    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 992px)'
    })


    const {
        register: dob,
        getValues,
        formState: { isValid },
        handleSubmit,
    } = useForm({
        mode: "onChange",
    });

    const today = dayjs().format('YYYY-MM-DD');

    const onChangeDob = (date) => {
        if (dayjs(date).isAfter(today)) {
            // setDisabledSubmit(true)
            appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: 'date of birth cannot be after today.', typeAlert: 'success' }
            });
            return;
        } else {
            setSelectedDob(date)
        }

    }



    useEffect(() => {
        if (typeof appState.user?.username !== 'undefined') {

            queries([{
                index: 'getMember',
                method: 'getMember',
                params: [
                    { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { username: appState.user.username } } }
                ],
                attributes: ['email', 'phone_number', ['_user',['name']], 'username', 'dob', 'currency']

            }, {
                index: 'getMemberAddress',
                method: 'getMemberAddress',
                params: [],
                attributes: []

            }]).then(({ data }) => {
                appDispatch({
                    type: APP_STORE_ACTION.SET_ADDRESS,
                    payload: data['getMemberAddress']
                });
                setUserInfo(data['getMember']?.[0])
            }).catch((error) => {
                // console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }
            })
        }


    }, [appState?.user?.username, queries, refreshBrithday, refreshAddress, appDispatch, navigate]);

    useEffect(() => {
        if (selectedDob !== '') {
            setDisabledSubmit(false)
        } else {
            setDisabledSubmit(true)
        }

    }, [selectedDob]);

    const onSubmit = () => {
        setLoading(true)
        const values = getValues();
        const method = 'changeDobByMember'
        let params = [
            { code: 'dob', graphqlType: 'Date', required: true, value: dayjs(selectedDob).format('YYYY-MM-DD') },
        ]

        mutation([{
            method,
            params,
            attributes: []

        }])
            .then(({ data }) => {
                setLoading(false)
                setDobEdit(false)
                setRefreshBrithday(true)
            })
            .catch((error) => {
                setLoading(false)
                console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }

            })


    };

    const onClickSetDefault = (item) => {
        setLoading(true)
        const method = 'updateMemberAddressDefault'
        let params = [
            { code: 'memberAddress', graphqlType: 'String', required: true, value: item.id },
        ]

        mutation([{
            method,
            params,
            attributes: []

        }])
            .then(({ data }) => {
                setLoading(false)
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: 'Set Default Successful', typeAlert: 'success' }
                });
                setRefreshAddress(!refreshAddress)
            })
            .catch((error) => {
                setLoading(false)
                console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }

            })
    }


    return (
        <>
            <div className="userInfo_body">
                {isDesktopOrLaptop ?
                    <div className="font_h2 color_primary wallet_container_title">{t('user_info')}</div> :
                    <Title id={"userInfo_title"} title={'user_info'} desktopToggle={false} mobileToggle={true} />}
                <div className="wallet_container_wrap">
                    <Row>
                        <Col lg={6}>
                            <Card className="myAccount_userInfo_profile">
                                <div className="subTitle">{t('personal_information')}</div>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item className="">
                                        <label>{t('username')}</label>
                                        <p>{userInfo?.username}</p>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="">
                                        <label>{t('dob')}</label>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <Col lg={9} md={10} xs={10}><Form.Control type="text" placeholder={"YYYY-MM-DD"} value={userInfo?.dob ?? ""} disabled /></Col>
                                            {!userInfo?.dob && (<Col lg={3} className="d-flex align-items-center justify-content-center "><FaEdit className="font_h2 cursor-pointer" onClick={() => setDobEdit(true)} /></Col>)}
                                        </div>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="">
                                        <label>{t('email')}</label>
                                        <p>{userInfo?.email}</p>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card>
                            <Card className="myAccount_userInfo_profile">
                                <div className="subTitle">{t('contact_information')}</div>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>
                                        <label>{t('phone_number')}</label>
                                        <p>{userInfo?.phone_number && (userInfo?.phone_number.slice(-4).padStart(userInfo?.phone_number.length, '*'))}</p>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <label>{t('full_name')}</label>
                                        <p>{userInfo?._user?.name}</p>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <label>{t('currency')}</label>
                                        <p>{userInfo?.currency}</p>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card>

                            {/* <Card className="myAccount_userInfo_profile">
                                <div className="subTitle">{t('banking_information')}</div>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>
                                        <div className="userInfo_bankDetails_container">
                                            <div className="userInfo_bankDetails_card">
                                                <div className="userInfo_bankDetails_bankLogo">
                                                    <img src={`${GLOBAL_BUCKET}/bank/MYR/MBBEMYKL.png`} alt={'bank icon'} />
                                                </div>
                                                <div className="userInfo_bankDetails_bankProfile">
                                                    <div>34732843224</div>
                                                    <div>hihihi</div>
                                                </div>
                                                <div className="userInfo_bankDetails_icon">
                                                    <FaRegCheckCircle />
                                                </div>
                                            </div>
                                        </div>
                                    </ListGroup.Item>

                                </ListGroup>
                            </Card> */}
                        </Col>

                    </Row>
                    <Card className="myAccount_userInfo_profile">
                        <div className="subTitle">{t('my_address')}</div>
                        <ListGroup className="list-group-flush userInfo_addressContainer">
                            {appState?.address.map(function (item) {
                                return (
                                    <ListGroup.Item key={item.id} className="userInfo_address">
                                        <div className="userInfo_addressInfo">
                                            <p><b>{appState?.user?.username}</b> | {item.address_name}</p>
                                            {item?.recipient_phone_number && (<p>+{item.recipient_phone_number}</p>)}
                                            <p>{item.address}</p>
                                            {item.isDefault && (<div className="address_default">{t('default')}</div>)}
                                        </div>
                                        <div className="userInfo_addressAction">
                                            <span className="address_edit" onClick={() => setAddressDialogShow({ open: true, defaultContent: 'userInfo_edit', currentItem: { ...item } })}>{t('edit')}</span>
                                            {!item.isDefault && (<div className="address_setDefault" onClick={() => onClickSetDefault(item)}>{t('set_as_default')}</div>)}
                                        </div>
                                    </ListGroup.Item>
                                )
                            })}

                        </ListGroup>
                        <button type="button" className="font_button color_button wallet_btnSubmit" onClick={() => setAddressDialogShow({ open: true, defaultContent: 'userInfo_add', currentItem: {} })}>{t('add_address')}</button>
                    </Card>

                </div>

                <Modal show={dobEdit} onHide={() => setDobEdit(false)} backdrop="static" centered id="dobEditModal">
                    <Modal.Header closeButton>
                        <Modal.Title>{t('dob')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group className="form_field" >
                                <Form.Label>{t('date')}<div className="form_required">*</div></Form.Label>
                                <div className="form_field_input">
                                    {/* <Form.Control
                                        type="date"
                                        name="dob"
                                        placeholder={t('dob')}
                                        className=" input_dob"
                                        aria-label="dob"
                                        autoComplete="off"
                                        {...dob("dob", {
                                            required: true
                                        }
                                        )}
                                    /> */}
                                    <DatePicker
                                        selected={selectedDob}
                                        onChange={(date) => onChangeDob(date)}
                                        dateFormat="yyyy-MM-dd"
                                        className="font_h5 input_dob form-control"
                                        placeholderText={'YYYY-MM-DD'}
                                        aria-label="input_dob"
                                    />
                                </div>
                            </Form.Group>
                            <input className="font_button color_button wallet_btnSubmit" type='submit' value={t('submit')} disabled={disabledSubmit} />
                            <div className="reminder_container">
                                <div className="reminder_title">{t('reminder')}</div>
                                <div className="reminder_content">
                                    {t(`dobEdit_reminder`)}
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
            <AddressDialog show={addressDialogShow?.open} onHide={() => setAddressDialogShow({...addressDialogShow,open:false})} defaultContent={addressDialogShow?.defaultContent} getData={addressDialogShow?.currentItem} />
            {isLoading && (<Loading />)}
        </>
    );

};






export default UserInfo;
